<h2 class="title-page">Mon compte</h2>
<!-- Display based on role -->
<!-- Role admin -->
<app-account-admin *ngIf='this.role === "Admin"'></app-account-admin>
<!-- Role provider -->
<app-account-provider *ngIf='this.role === "Provider"'></app-account-provider>
<!-- Role shop -->
<app-account-shop *ngIf='this.role === "Shop"'></app-account-shop>
